import { Injectable } from '@angular/core';
import { BillingService, WholesalePricingService } from '@galaxy/billing';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PurchaseCost } from './purchase-cost';

@Injectable({ providedIn: 'root' })
export class BillingApiService {
  constructor(
    private billingService: BillingService,
    private wholesalePricingService: WholesalePricingService,
  ) {}

  public getPurchaseCost(merchantId: string, sku: string, quantity: number): Observable<PurchaseCost> {
    return this.wholesalePricingService.getPurchaseCost(merchantId, sku, quantity).pipe(
      catchError(() => observableOf(null)),
      map((response) => PurchaseCost.fromGetPurchaseCostResponse(response)),
    );
  }

  public canBillCreateSnapshotStatusCode(merchantId: string): Observable<number> {
    return this.billingService.canBillCreateSnapshot(merchantId).pipe(
      catchError(() => observableOf(null)),
      map((response) => response.status),
    );
  }

  public canBillRefreshSnapshotStatusCode(merchantId: string): Observable<number> {
    return this.billingService.canBillRefreshSnapshot(merchantId).pipe(
      catchError(() => observableOf(null)),
      map((response) => response.status),
    );
  }
}
